import { z } from "zod";
import type { TFunction } from "i18next";

export function createOpenShiftSchema({ t }: { t: TFunction }) {
    return z.object({
        users: z.array(z.any()).min(1, { message: t("required-users") }),
        shifts: z.array(
            z.object({
                requestType: z.enum(["open-shift", "call-off"]),
                reason: z.string().min(1, { message: t("required-reason") }),
                payType: z.enum(["flat", "hourly"]),
                payAmount: z.union([
                    z.literal(""),
                    z.coerce.number({ message: t("invalid-amount") }).min(0, { message: t("invalid-amount") }),
                ]).optional(),
            }).passthrough()
        ).min(1, { message: t("required-shifts") }),
    });
}

export type OpenShiftFormValues = z.infer<ReturnType<typeof createOpenShiftSchema>>;
